import { QueryReturnValue } from 'node_modules/@reduxjs/toolkit/dist/query/baseQueryTypes';
import { constructQueryParams } from './query-params-builder';
import { MaybePromise } from 'node_modules/@reduxjs/toolkit/dist/query/tsHelpers';

type FetchWithBQ = (arg: string) => MaybePromise<QueryReturnValue<unknown, unknown, NonNullable<unknown>>>;

export const fetchResponse = async (
    ENDPOINT: string,
    idsArray: string[],
    fetchWithBQ: FetchWithBQ,
): Promise<QueryReturnValue> => {
    return await fetchWithBQ(
        constructQueryParams(ENDPOINT, {
            page: 1,
            size: idsArray.length,
            ids: idsArray.join(','),
        }),
    );
};

export const checkError = (response: QueryReturnValue) => {
    if (response.error) {
        return { error: response.error };
    }
};

export const buildQueryParams = <T extends object>(queryParamsObj: T) => {
    const queryParams = Object.entries(queryParamsObj)
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                return `${key}=${value.join(',')}`;
            }
            return `${key}=${value}`;
        })
        .join('&');

    return queryParams;
};
